<template>
  <div>
    <v-row v-if="isLoading">
      <v-col>
        <h-loading />
      </v-col>
    </v-row>
    <div v-if="!isLoading && Object.keys(city).length">
      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text mb-2">
            {{ $t('city.label.status') }}
          </h6>
          <v-chip :color="city.enabled ? 'primary' : ''">
            <span>
              {{ city.enabled ? $t('city.label.enabled') : $t('city.label.disabled') }}
            </span>
          </v-chip>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('city.label.name') }}
          </h6>
          <span class="font-weight-medium">
            {{ city.name }}
          </span>
        </v-col>
      </v-row>
        
      <v-row> 
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('city.label.state') }}
          </h6>
          <span class="font-weight-medium">
            {{ city.state.name + ' - ' + city.state.acronym }}
          </span>
        </v-col>
      </v-row>

      <v-row v-if="city.services.length > 0">
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('city.label.services') }}
          </h6>
          <div class="d-flex my-4" v-for="service in city.services" :key="service">
            <span
              class="host-resume-service-icon mr-2"
              v-html="handleGetIcon(service)"
            />
            <span class="font-weight-medium">
              {{ $t(`type.${service}`) }}
              <br>
            </span>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { icons } from '@/util/iconsSVG'

export default {
  name: 'CityOverview',

  props:{
      city: {
          required: true
      }
  },

  computed: {
    ...mapGetters(['isLoading']),
  },

  methods: {
    convertBooleanToString(booleanValue){
      return booleanValue ? "Sim" : "Não"
    },
    
    handleGetIcon(type) {
      return icons[type]
    }
  },
}
</script>

<style scoped>
  .host-resume-service-icon {
    width: 25px;
    height: 25px;
  }
</style>